import React, { createContext, useContext, useState } from 'react';
import { api } from 'app';

const RevisionsUIContext = createContext();

export function useRevisionsUIContext() {
  return useContext(RevisionsUIContext);
}

export function RevisionsUIProvider({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetchData = async (id, input) => {
    // remove "?" from query string
    const query = input.slice(1);

    api
      .get(`/adminPanel/events/${id}/revisions?include=event,user&${query}`)
      .then(response => {
        console.log(response.body.data);
        setData(response);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const value = {
    fetchData,
    data,
    setData,
    isLoading,
    setIsLoading
  };

  return <RevisionsUIContext.Provider value={value}>{children}</RevisionsUIContext.Provider>;
}
